import { reactive, computed} from 'vue';

import FormattingService from '@/services/formatting.service';
import InstructorCard from '@/components/content/blocks/instructor-card/instructor-card.vue';
import Card from '@/components/content/views/card/card.vue';

export default {
  name: 'Instructor',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      default: 1200,
    }
  },
  components: { 
    InstructorCard,
    Card
  },  
  setup(props) {
    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      isMobile: computed(() => props.width > 1199 ? false : true)
    });

    return {
      state,
      FormattingService,
    }
  }
}